import React from 'react'

import useConfig from 'pages/config/hooks/useConfig'

import { Container, Header } from 'component/template'
import TemplateAdmin from 'component/admin/TemplateAdmin'
import Tabs from 'pages/config/components/Tabs'

export default function Config() {
  const configHook = useConfig()

  /* =========================================== Output ========================================== */
  return (
    <TemplateAdmin>
      <Container>
        <Header pageName="Config" />

        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5>Config</h5>
              </div>
              <div className="card-body">
                <Tabs items={configHook.data.listConfigs} />
              </div>
            </div>
          </div>
        </div>
      </Container>
    </TemplateAdmin>
  )
}
